import { createActions, createReducer } from 'reduxsauce'

import AnexoService from '../servicos/AnexoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConteudoGrupoInicio: [],
    buscaConteudoGrupoSucesso: ['conteudo'],
    buscaConteudoGrupoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

Creators.buscaConteudoGrupo = id => {
    return dispatch => {
        dispatch(Creators.buscaConteudoGrupoInicio())
        let serv = new AnexoService()
        return serv
            .getAnexosPorConteudo(id)
            .then(response => dispatch(Creators.buscaConteudoGrupoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConteudoGrupoErro(error)))
    }
}

const buscaConteudoGrupoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaConteudoGrupoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConteudoGrupoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, conteudo: action.conteudo, carregando: false }
}

export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONTEUDO_GRUPO_ERRO]: buscaConteudoGrupoErro,
    [Types.BUSCA_CONTEUDO_GRUPO_INICIO]: buscaConteudoGrupoInicio,
    [Types.BUSCA_CONTEUDO_GRUPO_SUCESSO]: buscaConteudoGrupoSucesso,
})
